import React from 'react'
import {CoinsView} from './CoinsView'

const CoinsViewContainer: React.FC = () => {
  return <CoinsView />
}

export {CoinsViewContainer}
